// Two DOM helpers shared by the page modules.
export const $ = (s) => document.querySelector(s);
export const el = (tag, props = {}, ...kids) => { const n = Object.assign(document.createElement(tag), props); n.append(...kids); return n; };
